import { SET_DEVICE_WIDTH } from '../actions';

export const setDeviceWidth = (width) => {
    return {
        type: SET_DEVICE_WIDTH,
        payload: width
    };
};
